import React from 'react'
import reactStamp from 'react-stamp'
import {Table} from 'reactable'
import './appointments.css'

export default reactStamp(React).compose({

    render() {
        let upcomingData = [];
        for (let appointment in this.props.upcomingAppointments) {
            let row = {};
            row.Start = this.props.upcomingAppointments[appointment].start
            row.End = this.props.upcomingAppointments[appointment].end
            row.Provider = this.props.upcomingAppointments[appointment].actor;
            upcomingData.push(row);
        }

        return (
            <div className="upcoming-appointments-container">
                <h2 className="title">Upcoming Appointments</h2>
                <Table
                    className="table"
                    id="table"
                    data={upcomingData}
                    sortable={[
                        'Start',
                        'End',
                        'Provider',
                    ]}
                    defaultSort={{column: 'Start', direction: 'desc'}}
                />
            </div>
        )

    }

});


/** WEBPACK FOOTER **
 ** ./src/app/components/Appointments/UpcomingAppointmentsTable.js
 **/